export default "__VITE_ASSET__G6xOBqmV__"